import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';
import { IClinicBranding } from '../HealthcareFacility.ts';

export function useGetMyClinicBranding() {
  return useLowFrequencyRefreshQuery<IClinicBranding | undefined>({
    queryKey: [QueryKeys.clinicBranding],
    queryFn: () => HealthcareFacilitiesApi.getMyClinicBranding(),
  });
}
